var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding b-clr2"},[_c('div',{class:_vm.containerclass},[_vm._v(" "+_vm._s(_vm.content.source)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }